import carImage from '@/static/assets/home/animations-assets/car.svg';
import catImage from '@/static/assets/home/animations-assets/cat.svg';
import guyImage from '@/static/assets/home/animations-assets/guy.svg';
import guysImage from '@/static/assets/home/animations-assets/guys_on_bench.svg';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import Image from 'next/image';
import styled from 'styled-components';
import { IMAGE_STICK_TO_RIGHT_BREAKPOINT } from './LottieContainer';

export const CatAnimationStaticAsset = styled(Image).attrs({
  src: catImage,
  width: 781,
  height: 493,
  priority: true,
  alt: '',
})<{ animationCompleted: string[] }>`
  position: absolute;
  bottom: -2px;
  right: -7px;
  display: none;
  ${MEDIA_QUERIES.tabletAndDesktop`
    display: ${({ animationCompleted }) => (animationCompleted.includes('cat') ? 'none' : 'block')};
  `}
  @media (min-width: ${IMAGE_STICK_TO_RIGHT_BREAKPOINT}px) {
    right: 4px;
  }
`;

export const CarAnimationStaticAsset = styled(Image).attrs({
  src: carImage,
  width: 680,
  height: 245,
  priority: true,
  alt: '',
})<{ animationCompleted: string[] }>`
  position: absolute;
  bottom: -13px;
  right: -72px;
  display: none;
  ${MEDIA_QUERIES.desktop`
    display: ${({ animationCompleted }) => (animationCompleted.includes('cat') ? 'none' : 'block')};
  `}
`;
export const GuyAnimationStaticAsset = styled(Image).attrs({
  src: guyImage,
  width: 781,
  height: 493,
  priority: true,
  alt: '',
})<{ animationCompleted: string[] }>`
  position: absolute;
  bottom: -7px;
  left: auto;
  right: auto;
  transform: translateX(-1px);
  display: ${({ animationCompleted }) => (animationCompleted.includes('guy') ? 'none' : 'block')};
  @media (min-width: ${IMAGE_STICK_TO_RIGHT_BREAKPOINT}px) {
    left: auto;
    transform: translateX(1px);
    right: -168px;
  }
  ${MEDIA_QUERIES.mobile`
    height: 353px;
    bottom: 5px;
    right: -220px;
    left: auto;
  `}

  @media (max-width: 425px) {
    left: -95px;
  }
`;

export const GuysAnimationStaticAsset = styled(Image).attrs({
  src: guysImage,
  width: 781,
  height: 493,
  priority: true,
  alt: '',
})<{ animationCompleted: string[] }>`
  position: absolute;
  bottom: -7px;
  left: auto;
  right: auto;
  transform: translateX(-1px);
  display: ${({ animationCompleted }) => (animationCompleted.includes('guys') ? 'none' : 'block')};
  @media (min-width: ${IMAGE_STICK_TO_RIGHT_BREAKPOINT}px) {
    left: auto;
    transform: translateX(1px);
    right: -168px;
  }
  ${MEDIA_QUERIES.mobile`
    height: 353px;
    bottom: 5px;
    right: -220px;
    left: auto;
  `}

  @media (max-width: 425px) {
    left: -95px;
  }
`;
